module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "space-between",
      "align": "middle"
    }
  }, [_c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_vm._v("\n            " + _vm._s(_vm._f("showDateFormatted")(_vm.invoiceDue.invoicedate)) + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.invoiceDue.description) + "\n        ")]), _vm._v(" "), _c('Col', {
    staticClass: "brweb-flex",
    attrs: {
      "span": "3"
    }
  }, [_c('div', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("\n              " + _vm._s(_vm._f("currency")(_vm.invoiceDue.invoicefee)) + "\n          ")]), _vm._v(" "), _c('div', [_c('Tooltip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceDue.receivableDebitAmount != _vm.invoiceDue.invoicefee),
      expression: "invoiceDue.receivableDebitAmount != invoiceDue.invoicefee"
    }],
    attrs: {
      "placement": "top"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-help-outline"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [
    [_vm._v("\n                          Invoice Awal : " + _vm._s(_vm._f("currency")(_vm.invoiceDue.receivableDebitAmount)) + "\n                      ")]
  ], 2)], 1)], 1)]), _vm._v(" "), _c('Col', {
    staticClass: "brweb-flex",
    attrs: {
      "span": "3"
    }
  }, [(_vm.invoiceDue.invoicefee == _vm.invoiceDue.receivableRemaining) ? [_c('div', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm._f("currency")(_vm.invoiceDue.receivableRemaining)) + "\n              ")])] : [_c('div', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm._f("currency")(_vm.invoiceDue.receivableRemaining)) + "\n              ")])], _vm._v(" "), _c('div', [_c('Tooltip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceDue.receivableRemaining != _vm.invoiceDue.invoicefee),
      expression: "invoiceDue.receivableRemaining != invoiceDue.invoicefee"
    }],
    attrs: {
      "placement": "top"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-help-outline"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                      Total Bayar : " + _vm._s(_vm._f("currency")(_vm.invoiceDue.paymentSum)) + "\n                  ")])], 1)], 1)], 2), _vm._v(" "), (_vm.paymentGiroId == null) ? [_c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input ivu-input-small",
    model: {
      value: (_vm.allocateAmount),
      callback: function($$v) {
        _vm.allocateAmount = $$v
      },
      expression: "allocateAmount"
    }
  }, 'money', _vm.money, false)), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositRemaining > 0),
      expression: "depositRemaining > 0"
    }],
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n            Deposit "), _c('money', _vm._b({
    staticClass: "ivu-input ivu-input-small",
    model: {
      value: (_vm.useDepositAmount),
      callback: function($$v) {
        _vm.useDepositAmount = $$v
      },
      expression: "useDepositAmount"
    }
  }, 'money', _vm.money, false))], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.paymentGiroId) ? [_c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input ivu-input-small",
    model: {
      value: (_vm.allocateAmount),
      callback: function($$v) {
        _vm.allocateAmount = $$v
      },
      expression: "allocateAmount"
    }
  }, 'money', _vm.money, false)), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositRemaining > 0),
      expression: "depositRemaining > 0"
    }],
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n              Deposit "), _c('money', _vm._b({
    staticClass: "ivu-input ivu-input-small",
    model: {
      value: (_vm.useDepositAmount),
      callback: function($$v) {
        _vm.useDepositAmount = $$v
      },
      expression: "useDepositAmount"
    }
  }, 'money', _vm.money, false))], 1)], 1)] : _vm._e(), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('div', [(_vm.paymentGiroId) ? _c('div', [_c('money', _vm._b({
    staticClass: "ivu-input ivu-input-small",
    on: {
      "input": _vm.maximalDiscount
    },
    model: {
      value: (_vm.discountAmount),
      callback: function($$v) {
        _vm.discountAmount = $$v
      },
      expression: "discountAmount"
    }
  }, 'money', _vm.money, false))], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', [(_vm.paymentGiroId) ? _c('div', [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Keterangan Potongan")]), _c('Input', {
    attrs: {
      "placeholder": ". . . ",
      "size": "small"
    },
    model: {
      value: (_vm.discountDescription),
      callback: function($$v) {
        _vm.discountDescription = $$v
      },
      expression: "discountDescription"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositMutasiRemaining > 0),
      expression: "depositMutasiRemaining > 0"
    }],
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n          Deposit Mutasi "), _c('money', _vm._b({
    staticClass: "ivu-input ivu-input-small",
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.useDepositMutasi),
      callback: function($$v) {
        _vm.useDepositMutasi = $$v
      },
      expression: "useDepositMutasi"
    }
  }, 'money', _vm.money, false))], 1)]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_c('div', [_c('div', [_c('Button-group', {
    attrs: {
      "size": "small"
    }
  }, [_c('Button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.toggleAllocateAll()
      }
    }
  }, [_vm._v("All")])], 1)], 1)])])], 2), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "24"
    }
  }, [_c('br'), _vm._v(" "), _c('hr')])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b7fda71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/giro/cInvoicePayment.vue
// module id = 1835
// module chunks = 1